<template>

</template>

<script>
export default {
  name: 'BettingBotPolling',
  data:function(){
    return {
      selectedMarketPolling:'',
      botMarketMakingTreePolling:'',
      tournamentMarketsPolling:''
    }
  },

  computed:{
    selectedMarket: function () {
      return this.$store.state.trader.bettingBot.selectedMarket;
    },
    isTrader:function(){
      return this.$store.state.user.isTrader
    },
    botMarketMakingTree: function () {
      return this.$store.state.trader.bettingBot.supportedSportsMap;
    },
    selectedEvent: function (event) {
      return this.$store.state.navigations.selectedEvent;
    }
  },
  watch:{
    selectedMarket:function (newMarket,oldMarket) {
      if(newMarket.id && newMarket.id !== oldMarket.id){
        clearInterval(this.selectedMarketPolling);

        this.selectedMarketPolling = setInterval(function () {
          this.$store.dispatch('getMarketBotConfigSilent',newMarket.id);
        }.bind(this),5000)
      } else if(typeof newMarket.id ==='undefined'){
        clearInterval(this.selectedMarketPolling);
      };
    },
    selectedEvent:function (newEvent,oldEvent) {
      if(newEvent !=='none'){
        clearInterval(this.tournamentMarketsPolling);

        this.tournamentMarketsPolling = setInterval(function () {
          this.$store.dispatch('getSupportedMarketsForTournament',newEvent.tournamentId);
        }.bind(this),20000)

      } else{
        clearInterval(this.tournamentMarketsPolling);
      };
    }
  },
  mounted:function() {
    if(this.selectedMarket.id && this.selectedMarket.id !== this.selectedMarket.id){
      this.selectedMarketPolling = setInterval(function () {
        this.$store.dispatch('getMarketBotConfigSilent',this.selectedMarket.id);
      }.bind(this),5000)
    };
    this.botMarketMakingTreePolling = setInterval(function () {
      this.$store.dispatch('getBotSupportedMarkets');
    }.bind(this),20000)
    if(this.selectedEvent !=='none'){
      clearInterval(this.tournamentMarketsPolling);

      this.tournamentMarketsPolling = setInterval(function () {
        this.$store.dispatch('getSupportedMarketsForTournament',this.selectedEvent.tournamentId);
      }.bind(this),20000)

    };
  }
};
</script>

<style scoped>

</style>
